<template>
    <q-page>
        <div class="q-pa-md">
            <div class="row">
                <div class="col-md-12">
                    <div class="text-h6">Incidencias</div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <q-table dense :pagination="{ rowsPerPage: 15 }" :rows-per-page-options="[0]" virtual-scroll flat
                        bordered :rows="incidencias" separator="cell">
                        <template v-slot:header>
                            <q-tr class="bg-dark text-white">
                                <q-th key="NIP" auto-width align="left">NIP</q-th>
                                <q-th key="RFC" auto-width align="left">RFC</q-th>
                                <q-th key="Incidencia" align="left">Incidencia</q-th>
                                <q-th key="Fecha" auto-width align="left">Fecha</q-th>
                                <q-th key="HoraEntrada" auto-width align="left">Entrada</q-th>
                                <q-th key="HoraSalida" auto-width align="left">Salida</q-th>
                            </q-tr>
                        </template>
                        <template v-slot:body="props">
                            <q-tr
                                v-bind:style="[props.row.Incidencia.Resaltar == true ? { 'background': props.row.Incidencia.Color } : { 'background': 'transparent' }]">
                                <q-td style="white-space:pre-line">{{ nip }}</q-td>
                                <q-td style="white-space:pre-line">{{ props.row.RFC }}</q-td>
                                <q-td style="white-space:pre-line">{{ props.row.Incidencia.Descripcion }}</q-td>

                                <q-td auto-width>{{ formatDate(new Date(props.row.Fecha)) }}</q-td>
                                <!-- <q-td auto-width>{{ new Date(props.row.Fecha).toISOString().slice(0,10) }}</q-td> -->
                                <q-td style="white-space:pre-line">{{ props.row.HoraEntrada }}</q-td>
                                <q-td style="white-space:pre-line">{{ props.row.HoraSalida }}</q-td>
                            </q-tr>
                        </template>
                    </q-table>
                </div>
            </div>
        </div>

    
    </q-page>
</template>
<script>
import http from "@/services/http"

export default {
    data: () => ({
        incidencias: [],
        rfc:'',
        nip:0
    }),
    methods: {
        async initialize() {
            var sp = JSON.parse(localStorage.getItem('sicope-user'));
            this.rfc = sp.Usuario;
            this.nip = sp.IdUsuario;
            await this.cargaIncidencias();
        },
      
        async cargaIncidencias() {
            this.incidencias = await http.getVisor(`visor/incidencias/${this.rfc}`)
            console.log(this.incidencias);
        },
          formatDate(date) {
            return [
                date.getDate().toString().padStart(2, '0'),
                (date.getMonth() + 1).toString().padStart(2, '0'),
                date.getFullYear(),
            ].join('/');
        },
    },
    created() {
        this.initialize();
    },
}
</script>
